import { popupActions } from '../../services';

export const popupDispatcher = dispatch => ( {
  setPopup: ( { title, component, showHeader = true, keepOpen = false, onClose, showConfirmation, disclaimers,isEdit,isFeasibilityPopup, className } ) => dispatch( { 
    type: popupActions.SETPOPUP, 
    popup: { 
      show: true, 
      content: component, 
      title,
      header: showHeader,
      keepOpen,
      onClose,
      showConfirmation,
      isFeasibilityPopup,
      isEdit,
disclaimers,
    className
    } } ),
  hidePopup: id => dispatch( { type: popupActions.HIDEPOPUP, id } ),
  updatePopup: value => dispatch( { type: popupActions.UPDATEPOPUP, value } )
} );
